import { Position } from '@iotv/iotv-v3-types'

export type IrrigatorProps = {
  // travellingCurrentLocation?: Position
  fixedThrowArea?: number
  travellingThrowArea?: number
  applicationPotential?: number
  hasDevice?: boolean
  isOperating?: boolean
  updated_at?: number
  timestamp: number
  // solenoidModel?: SolenoidTypes
  solenoidVoltage?: number
  solenoidVoltageEUI?: string
  desiredVoltage?: number
}

export enum IrrigatorType {
  Solid_State = 'Solid State',
  Pivot = 'Pivot',
  Lateral = 'Lateral',
  Traveling = 'Traveling',
  KLine = 'K-Line',
  Gun = 'Gun',
}

export enum SprinklerType {
  'Senninger 8025' = 'Senninger 8025',
  'Senninger 8025-2ED' = 'Senninger 8025-2ED',
  'Senninger 8025-2RD' = 'Senninger 8025-2RD',
  'Senninger 8025-2SD' = 'Senninger 8025-2SD',
  'Komet K162 (FC)' = 'Komet K162 (FC)',
  'Komet K163 (PC)' = 'Komet K163 (PC)',
  'Sime Hydra (PC)' = 'Sime Hydra (PC)',
  'Senior (FC & PC)' = 'Senior (FC & PC)',
  'K1 (PC)' = 'K1 (PC)',
}

export enum SprinklerCoverage {
  '90 degrees' = '90',
  '180 degrees' = '180',
  '270 degrees' = '270',
  '360 degrees' = '360',
}

export const default_solenoid_voltage = 12

// export type SolenoidTypes = 'Baccara' | 'Dorot'
// export const SolenoidOptions = ['Baccara', 'Dorot']

// export const SolenoidVoltageMapper: { [k in SolenoidTypes]: number } = {
//   Baccara: 9,
//   Dorot: 12,
// }
